import styles from './Loader.module.scss';

type LoaderProps = {
  /**
   * The progress of the loader, from 0 to 100.
   */
  progress: number;
};

export const Loader = ({ progress }: LoaderProps) => {
  return (
    <div className={styles.container} role="progressbar" aria-valuenow={progress}>
      <div className={styles.label} style={{ left: `${progress}%` }}>
        {progress}%
      </div>
      <div className={styles['bar-container']}>
        <div className={styles.bar} style={{ width: `${progress}%` }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="322" height="22" viewBox="0 0 322 22" fill="none">
            <path
              d="M3 15.3333L15.6237 3L22.1392 19L35.5773 3L39.2423 17L53.9021 3L60.8247 17L73.8557 4L81.1856 17L92.5876 4L99.1031 17L119.464 4L122.314 17L134.124 4L143.897 17L153.67 3L162.629 17L181.361 3L189.912 15.3333L198.871 4L212.716 17L231.856 4L241.629 16.3333L257.918 4L263.211 17L276.242 4L289.68 17L299.454 5.33333L304.747 17L319 4"
              stroke="currentColor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
